<template>
  <div style="height: 100%">
    <v-snackbar class="pa-0" light timeout="-1" v-model="alertShow" width="fit-content" top centered>
      <v-alert
          v-model="alertShow"
          dismissible
          :icon="alertSuccess ? 'check_circle' : 'cancel'"
          class="mb-0 pa-1"
          :class="alertSuccess ? 'profile-alert-success' : 'profile-alert-failed'"
          light
          close-icon="close"
      >
        {{ alertMessage }}
      </v-alert>
    </v-snackbar>
    <v-card class="desktop_voucher_card">
      <v-card class="voucher-card" elevation="0">
        <v-row no-gutters align="end" v-if="voucherCheckComplete" class="pb-5 px-6">
          <v-col cols="10" class="pb-2" v-if="voucherCheck.data.bonusIsUseFreespin">
            <label class="field-name-desktop">{{ $t(`field.freegame`) }}</label>
          </v-col>
          <v-col md="5" class="pa-2 filled-label-voucher" v-if="voucherCheck.data.bonusIsUseFreespin">
            {{ voucherCheck.data.bonusFreespinGameName }}
          </v-col>
          <v-col cols="10" class="pb-2" v-if="voucherCheck.data.bonusIsUseFreespin">
            <label style="font-size: 13px">{{ $t(`fieldHint.voucherFreespinNotify`) }}</label>
          </v-col>
          <v-col md="10" class="pb-2" v-if="voucherCheck.data.bonusIsUseFreespin">
            <label class="field-name-desktop">{{ $t(`field.freegameBet`) }}:</label>
          </v-col>
          <v-col cols="12" class="pb-2" v-else>
            <label class="field-name-desktop">{{ $t(`field.bonusAmount`) }}:</label>
          </v-col>
          <v-col cols="12" class="pa-2 filled-label-voucher" v-if="voucherCheck.data.bonusIsPercentage">
            {{ currencyFormatter(voucherCheck.data.bonusPercentage, currency) }}
          </v-col>
          <v-col cols="12" class="pa-2 filled-label-voucher" v-else>
            {{ currencyFormatter(voucherCheck.data.bonusGivenAmount, currency) }}
          </v-col>
          <v-col md="10" class="py-2" v-if="voucherCheck.data.bonusIsUseFreespin">
            <label class="field-name-desktop">{{ $t(`field.freegameRound`) }}:</label>
          </v-col>
          <v-col md="5" class="pa-2 filled-label-voucher" v-if="voucherCheck.data.bonusIsUseFreespin">
            {{ voucherCheck.data.bonusFreespinRound }}
          </v-col>
          <v-col cols="12" class="py-2">
            <label class="field-name-desktop">{{ $t(`field.targetTurnover`) }}:</label>
          </v-col>
          <v-col cols="12" class="pa-2 filled-label-voucher">
            {{ currencyFormatter(voucherCheck.data.bonusTargetRollover, currency) }}
          </v-col>
          <v-col cols="12" class="py-2">
            <label class="field-name-desktop">{{ $t(`field.voucherExpires`) }}:</label>
          </v-col>
          <v-col md="5" class="pa-2 filled-label-voucher" v-if="voucherCheck.data.bonusIsUseFreespin">
            {{ voucherCheck.data.bonusFreespinExpired }}
          </v-col>
          <v-col cols="12" class="pa-2 filled-label-voucher" v-else>
            {{ voucherCheck.data.voucher_expires }}
          </v-col>
          <v-col cols="12" class="py-2">
            <label class="field-name-desktop">{{ $t(`field.turnoverRequirements`) }}:</label>
          </v-col>
          <v-col cols="12" class="pa-2 filled-label-voucher" v-if="!voucherCheck.data.bonusIsUseFreespin">
            {{ currencyFormatter(voucherCheck.data.deposit_needed, currency) }}
          </v-col>
          <v-col cols="12" class="pt-6 text-center">
            <v-btn height="auto" @click="applyVoucher" color="#47206F" depressed class="voucher-width primary-button theme-button text-capitalize pa-2 white--text">
              {{ $t(`label.claim`) }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row no-gutters align="end" v-else class="pb-5 px-6">
          <v-col cols="12" class="pb-2">
            <label class="field-name-desktop red--text">{{ errorCodeDesc }}</label>
          </v-col>
        </v-row>
      </v-card>
    </v-card>
    <app-dialog :dialogShow="msgDialog.show" ref="claimVoucherDetailDialog" :max-width="400" :title="voucherObj.code" :header_title="'editProfile'" :closeAction="this.onCloseClick">
      <v-row no-gutters justify="center" :class="$vuetify.breakpoint.mdAndDown ? 'px-3' : 'px-5'">
        <!-- Freegame Bet / Bonus Amount -->
        <v-row no-gutters align="center" class="w-100 voucher-row">
          <v-col cols="6">
            <label class="voucher-claim-dialog-title">
              {{ voucherCheck.data.bonusIsUseFreespin ? $t('field.freegameBet') : $t('field.bonusAmount') }}
            </label>
          </v-col>
          <v-col cols="6" class="text-right">
        <span v-if="voucherCheck.data.bonusIsPercentage">
          {{ currencyFormatter(voucherCheck.data.bonusPercentage, currency) }}
        </span>
            <span v-else>
          {{ currencyFormatter(voucherCheck.data.bonusGivenAmount, currency) }}
        </span>
          </v-col>
        </v-row>

        <!-- Freegame Round -->
        <v-row no-gutters align="center" class="w-100 mt-2 voucher-row" v-if="voucherCheck.data.bonusIsUseFreespin">
          <v-col cols="6">
            <label class="voucher-claim-dialog-title">{{ $t(`field.freegameRound`) }}</label>
          </v-col>
          <v-col cols="6" class="text-right">
            {{ voucherCheck.data.bonusFreespinRound }}
          </v-col>
          <v-col cols="6" class="mt-2">
            <label class="voucher-claim-dialog-title">{{ $t(`field.freegame`) }}</label>
          </v-col>
          <v-col cols="6" class="text-right">
            {{ voucherCheck.data.bonusFreespinGameName }}
          </v-col>
          <v-col cols="12">
            <label style="font-size: 13px">{{ $t(`fieldHint.voucherFreespinNotify`) }}</label>
          </v-col>
        </v-row>

        <!-- Target Turnover -->
        <v-row no-gutters align="center" class="w-100 mt-2 voucher-row">
          <v-col cols="6">
            <label class="voucher-claim-dialog-title">{{ $t(`field.targetTurnover`) }}</label>
          </v-col>
          <v-col cols="6" class="text-right">
            {{ currencyFormatter(voucherCheck.data.bonusTargetRollover, currency) }}
          </v-col>
        </v-row>

        <!-- Voucher Expires -->
        <v-row no-gutters align="center" class="w-100 mb-6 mt-2 voucher-row">
          <v-col cols="6">
            <label class="voucher-claim-dialog-title">{{ $t(`field.voucherExpires`) }}</label>
          </v-col>
          <v-col cols="6" class="text-right">
        <span v-if="voucherCheck.data.bonusIsUseFreespin">
          {{ voucherCheck.data.bonusFreespinExpired }}
        </span>
            <span v-else>
          {{ voucherCheck.data.voucher_expires }}
        </span>
          </v-col>
        </v-row>

        <v-col cols="8">
          <v-btn height="auto" @click="applyVoucher" color="black" depressed class="primary-button theme-button text-capitalize pa-2 font-weight-bold yellow--text">{{ $t(`label.confirm`) }}</v-btn>
        </v-col>
      </v-row>
    </app-dialog>
  </div>
</template>

<script>
import AppGameCard from '../../components/home/GameCard'
import {errorCodeHelper, formValidator, uiHelper} from '@/util'
import {
  GET_VOUCHER_CODE,
  GET_VOUCHER_CODE_RESET,
  VOUCHER_BONUS_APPLY,
  VOUCHER_BONUS_APPLY_RESET,
  VOUCHER_BONUS_CHECK,
  VOUCHER_BONUS_CHECK_MOBILE_RESET,
  VOUCHER_BONUS_CHECK_RESET
} from '../../store/bonus.module'
import currencyFormat from "@/filters/currency-format";
export default {
  name: 'claimVoucherDialog',
  components: {
    AppGameCard
  },
  props: {
    bonusId: {
      type: Number,
      required: true,
      default: 0
    },
  },
  data: () => ({
    currencyFormatter: currencyFormat,
    currency: uiHelper.getCurrency(),
    validator: formValidator,
    voucherObj: {
      code: ''
    },
    msgDialog: {
      show: false,
      title: '',
      msg: ''
    },
    voucherCheckComplete: false,
    codeIsValid: false,
    alertShow: false,
    alertSuccess: true,
    alertMessage: '',
    voucherCheck: {
      data: {}
    },
    errorCodeDesc: ''
  }),
  computed: {
    voucherCheckResult() {
      return this.$store.state.bonus.checkVoucherResponse.complete
    },
    voucherCheckResultMobile() {
      return this.$store.state.bonus.checkVoucherMobileResponse.complete
    },
    voucherApplyResult() {
      return this.$store.state.bonus.applyVoucherResponse.complete
    },
    voucherCode() {
      return this.voucherObj.code
    },
    voucherCodeResult() {
      return this.$store.state.bonus.voucherCode.complete
    }
  },
  watch: {
    voucherApplyResult() {
      if (this.$store.state.bonus.applyVoucherResponse.complete) {
        this.openResultDialog(this.$store.state.bonus.applyVoucherResponse)
      }
    },
    voucherCheckResult() {
      if (this.$store.state.bonus.checkVoucherResponse.complete) {
        this.voucherDesktop = this.$store.state.bonus.checkVoucherResponse
        this.showResponse(this.voucherDesktop)
      }
    },
    voucherCheckResultMobile() {
      if (this.$store.state.bonus.checkVoucherMobileResponse.complete) {
        this.voucherCheck = this.$store.state.bonus.checkVoucherMobileResponse
        this.openConfirmDialog(this.voucherCheck)
      }
    },
    voucherCodeResult() {
      if (this.$store.state.bonus.voucherCode.complete) {
        this.voucherObj.code = this.$store.state.bonus.voucherCode.data.code;
        this.onClaimVoucherDesktopClick()
      }
    },
  },
  created() {
    this.getVoucherCode();
  },
  methods: {
    openAlert(success, msg) {
      this.alertSuccess = success
      this.alertMessage = msg
      this.alertShow = true
    },
    getVoucherCode() {
      const filter = {
        id: this.bonusId
      }
      this.$store.dispatch(`${GET_VOUCHER_CODE}`, {filter})
          .then(() => {
            this.$store.dispatch(`${GET_VOUCHER_CODE_RESET}`)
          })
    },
    onClaimVoucherDesktopClick() {
        const voucherObj = this.voucherObj
        this.$store.dispatch(`${VOUCHER_BONUS_CHECK}`, {voucherObj})
            .then(() => {
              this.$store.dispatch(`${VOUCHER_BONUS_CHECK_RESET}`)
            })
    },
    openResultDialog(result) {
      if (result.code != 0 && !result.success) {
        this.openAlert(false, errorCodeHelper.getErrorCodeDesc(result.code))
      } else {
        this.$emit('close-dialog');
      }
      this.$store.dispatch(`${VOUCHER_BONUS_CHECK_RESET}`)
      this.$store.dispatch(`${VOUCHER_BONUS_CHECK_MOBILE_RESET}`)
      this.$store.dispatch(`${VOUCHER_BONUS_APPLY_RESET}`)
    },
    openConfirmDialog(result) {
      if (result.code != 0 && !result.success) {
        this.openAlert(false, errorCodeHelper.getErrorCodeDesc(result.code))
        this.$store.dispatch(`${VOUCHER_BONUS_CHECK_RESET}`)
        this.$store.dispatch(`${VOUCHER_BONUS_CHECK_MOBILE_RESET}`)
      } else {
        this.msgDialog.show = true
      }
    },
    showResponse(result) {
      if (result.code != 0 && !result.success) {
        this.errorCodeDesc = errorCodeHelper.getErrorCodeDesc(result.code);
        this.voucherCheckComplete = false
      } else {
        this.voucherCheckComplete = false
        this.openAlert(true, 'Voucher Is Applied')
        this.voucherCheck = result
        this.voucherCheckComplete = true
      }
    },
    applyVoucher() {
      const voucherObj = this.voucherObj
      this.$store.dispatch(`${VOUCHER_BONUS_APPLY}`, {
        voucherObj
      })
      this.msgDialog.show = false
    },
    onCloseClick() {
      this.$store.dispatch(`${VOUCHER_BONUS_CHECK_RESET}`)
      this.$store.dispatch(`${VOUCHER_BONUS_CHECK_MOBILE_RESET}`)
      this.msgDialog.show = false
    },
  }
}
</script>

<style lang="scss">
.desktop_voucher_card {
  border-radius: 12px !important;
  height: 100%;
  font-family: 'Roboto', sans-serif;
  box-shadow: none !important;

  .voucher-desktop-txt {
    font-weight: bold;
  }
}

.voucher-width {
  width: 50% !important;
  border-radius: 32px !important;
  min-width: 180px !important;
}

.filled-label-voucher {
  border: 1px solid #d3d3d3;
  background-color: #f3f5f6;
  color: #6c6c6c;
  font-weight: bold;
  border-radius: 32px;
  height: 40px;
}
.field-name-desktop {
  color: #000;
}

.voucher-box .v-text-field--outlined fieldset {
  border-color: #d3d3d3;
}

.voucher-checking {
  background-color: #FF9E2D !important;
  height: 40px;
  min-width: 150px !important;
  font-family: 'Roboto', sans-serif !important;
  border-radius: 32px !important;
  font-size: 12px;
  color: white !important;
}

.voucher-border {
  border-color: #d3d3d3;
  border-width: 1px;
}

.voucher-mobile-header {
  background-color: #000000;
  color: var(--v-newMobilePrimary-base);
  margin-top: auto;
  margin-bottom: auto;
}
.voucher-card {
  height: 80%;
}
.voucher-claim-dialog-title {
  color: #acacac;
}

@media (max-width: 959px) {
  .submit-btn.buttonPrimary {
    background-color: var(--v-newMobileSecondary-base) !important;
    color: #ffffff;
  }
}
</style>
